import api from './api';
import type { LocationOpt } from './contstatusreport.service';

/**
 * Dal Tile Template Mapping — option bundle for the drawer + the Legal/Overweight
 * template search-as-you-type (V1 templatelookup, surfaced inline).
 */
export interface RdcOpt { value: string; label: string; }
export interface ScacOpt { scac: string; name: string; }

export interface DalTileOptions {
  rdcs: RdcOpt[];
  portdestinations: string[];
  scacs: ScacOpt[];
  rails: string[];
  locations: LocationOpt[];
}

export interface TemplateMatch {
  template: string;
  type: string;
  movetype: string;
  csr: string;
  mode: string;
  customer: string;
  invoicetotal: string;
  destination: string;
}

export async function getDalTileOptions(): Promise<DalTileOptions> {
  const res = await api.get('/daltile/form-options');
  return res.data as DalTileOptions;
}

export async function searchTemplates(q: string): Promise<TemplateMatch[]> {
  const res = await api.get('/daltile/template-search', { params: { q } });
  return (res.data?.results || []) as TemplateMatch[];
}

/** Carrier match for the Dal Tile Carrier Mapping lookup (highway.carrierprofile). */
export interface CarrierMatch {
  recno: number;
  scac: string;
  name: string;
  mcnum: string;
  dotnum: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  confirmed: string;
}

export async function searchCarriers(q: string): Promise<CarrierMatch[]> {
  const res = await api.get('/daltile/carrier-search', { params: { q } });
  return (res.data?.results || []) as CarrierMatch[];
}
